module.exports = __webpack_public_path__ + "static/media/map-icon.04e04149.jpg";